"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-imverified-dev"
  }, [_c('div', {
    staticClass: "dev-overlay"
  }, [_c('div', {
    staticClass: "dev-content-card"
  }, [_c('div', {
    staticClass: "dev-icon"
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('h1', {
    staticClass: "dev-title"
  }, [_vm._v("PRÓXIMAMENTE")]), _c('div', {
    staticClass: "dev-divider"
  }), _c('p', {
    staticClass: "dev-text"
  }, [_vm._v(" En desarrollo. Estamos construyendo un espacio donde podrás monetizar tu contenido. Te protegemos en el anonimato. Y tú colaboras con nuestro ecosistema dando un buen servicio a tus suscriptores. ")]), _c('div', {
    staticClass: "dev-footer"
  }, [_c('span', [_vm._v("I'm Verify")])])])])]);
}];